export default {
  regions: 1,
  clusters: 2,
  locations: 3, 
  search: 4,
};
